<template>
    <div>
        <v-simple-table v-if="$vuetify.breakpoint.smAndUp">
            <thead>
                <tr>
                    <th>Trampoline</th>
                    <th>Double Mini</th>
                    <th>Tumbling</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ result.tra_result?.prelims_score }}</td>
                    <td>{{ result.dmt_result?.prelims_score }}</td>
                    <td>{{ result.tum_result?.prelims_score }}</td>
                </tr>
            </tbody>
        </v-simple-table>
    </div>
</template>

<script>
import AllAroundResult from '@/Models/AllAroundResult.js';

export default {
    name: 'AllAroundHighlight',

    props: {
        result: {
            type: AllAroundResult,
            required: true,
        },
    },

    data: () => ({}),

    computed: {
        latestResult() {
            return this.result.latest_result;
        },

        event() {
            return 'Trampoline';
        },
    },
};
</script>

<style lang="scss" scoped>
th,
td {
    font-size: 1.2rem;
    text-align: left;
    padding: 0 !important;
}

td {
    font-size: 1rem;
}
</style>
